export default __webpack_public_path__ + "static/BundesSans-Web-Bold-63286347b4ac50c4c892055b6ae96e3e.woff";